function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M400 80c176.731 0 320 143.269 320 320S576.731 720 400 720 80 576.731 80 400 223.269 80 400 80zm93.262 358.262L400 531.52l-93.22-93.214-54.313 54.161.077.077L400 640l147.504-147.498.027-.029-54.269-54.211zM400 344.932L359.321 385.6l-4.673 4.675-9.639 9.64-.077.075.077.08L400 455.067l55.039-55.04.027-.03-.05-.027h.019L400 344.932zm185.762.85l-54.242 54.241 54.24 54.238L640 400.02l-54.238-54.238zm-371.52-.032L160 400l54.238 54.23 54.242-54.242-54.238-54.238zM400 160L252.544 307.456l54.238 54.24-.002.004L400 268.48l93.264 93.26 54.24-54.24L400 160z",
  fill: "#F3BA2F",
  fillRule: "evenodd"
});

function SvgBnb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 800 800"
  }, props), _ref);
}

export default __webpack_public_path__ + "3839c23a69b60dc03c0261a810084699.svg";
export { SvgBnb as ReactComponent };